import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;

export const InputUpperWrapper = styled.div`
  display: flex !important;
  flex-direction: column !important;
`;

export const Box = styled.div`
  width: 100%;
  position: relative;
`;
export const SpinnerBox = styled.div`
  width: 200px;
  height: 200px;
  position: relative;
  top: -40px;
  margin: auto;
  & svg {
    animation-name: rotate;
    -webkit-animation-name: rotate;
    -moz-animation-name: rotate;
    animation-duration: 1.8s;
    -webkit-animation-duration: 1.8s;
    -moz-animation-duration: 1.8s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    height: 100%;
    width: 100%;
  }
`;

export const HeadingContent = styled.span`
  font-size: 24px;
  font-weight: 500;
`;

export const HeadingBlock = styled.div`
  margin-top: 100px;
  text-align: center;
`;

export const Search = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const InputBox = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  padding-bottom: 24px;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;
